<template>
  <div class="personalize-container flex flex-col absolute w-full rounded-md xs-sm:w-11/12">
    <div class="menu-exit" id="exit-menu" @click="closeMenu">
    </div>
    <div class="personalize-upper flex flex-col text-center p-5 rounded-t-md sm:flex-wrap">
      <h1 class="text-3xl font-bold mt-8">{{ this.$translations[this.$root.language].cookiesManagement }}</h1>
      <hr class="personalize-separator w-9/12" />
      <p class="-">{{ this.$translations[this.$root.language].allowingThirdParty }}</p>
      <hr class="personalize-separator w-9/12"/>
      <div class="flex flex-col w-full justify-center items-center sm:flex-wrap sm:flex-row">
        <p class="mb-4 hidden">{{ this.$translations[this.$root.language].servicesPreference }}</p>
        <button id="allow-all" :class="this.$root.allowAllCookies === true && this.$root.cookiePolicySelected === true ? 'allow' : ''" class="bg-gray-300 text-white mx-4 mb-5 p-3 rounded-sm w-8/12 sm:mb-0 sm:w-5/12 sm:mr-2" @click="processCookiePolicy(true, 'allowAllCookies')">{{ this.$translations[this.$root.language].cookiePolicyAccept }}</button>
        <button id="deny-all" :class="this.$root.essentialCookiesOnly === true && this.$root.cookiePolicySelected === true ? 'deny' : ''" class="bg-gray-300 text-white mx-4 p-3 rounded-sm w-8/12 sm:w-5/12 sm:ml-2" @click="processCookiePolicy(false, 'essentialCookiesOnly')">{{ this.$translations[this.$root.language].cookiePolicyReject }}</button>
      </div>
    </div>
    <div id="personalize-lower" class="personalize-lower flex flex-col py-5 justify-center items-center">
      <div class="w-auto">
        <div class="essential-cookies flex flex-col mb-5 flex-wrap px-5">
          <h2 class="w-full font-bold mb-2">Essential Cookies</h2>
          <div class="flex flex-row w-full">
            <button disabled class="cookie-button bg-gray-400 text-white mr-4 p-3 rounded-sm sm:mb-0 w-32">{{ this.$translations[this.$root.language].allow }}</button>
          </div>
        </div>
        <div class="calculation-cookies flex flex-col mb-5 flex-wrap px-5">
          <h2 class="w-full font-bold mb-2">Website Cookies</h2>
          <div class="flex flex-row w-full">
            <button id="website-cookies-allow" :class="this.$root.websiteCookies === true ? 'allow' : ''" class="allow-button cookie-button bg-gray-300 text-white mr-4 p-3 rounded-sm sm:mb-0 w-32" @click="processCookiePolicy(true, 'websiteCookies')">{{ this.$translations[this.$root.language].allow }}</button>
            <button id="website-cookies-deny" :class="this.$root.websiteCookies === false ? 'deny' : ''" class="deny-button cookie-button bg-gray-300 text-white ml-4 p-3 rounded-sm w-32" @click="processCookiePolicy(false, 'websiteCookies')">{{ this.$translations[this.$root.language].deny }}</button>
          </div>
        </div>
        <div class="location-cookies flex flex-col mb-5 flex-wrap px-5">
          <h2 class="w-full relative font-bold mb-2">Abstract API IPGeolocation</h2>
          <div class="flex flex-row w-full">
            <button id="abstract-cookies-allow" :class="this.$root.abstractCookies === true ? 'allow' : ''" class="allow-button cookie-button bg-gray-300 text-white mr-4 p-3 rounded-sm sm:mb-0 w-32" @click="processCookiePolicy(true, 'abstractCookies')">{{ this.$translations[this.$root.language].allow }}</button>
            <button id="abstract-cookies-deny" :class="this.$root.abstractCookies === false ? 'deny' : ''" class="deny-button cookie-button bg-gray-300 text-white ml-4 p-3 rounded-sm w-32" @click="processCookiePolicy(false, 'abstractCookies')">{{ this.$translations[this.$root.language].deny }}</button>
          </div>
          <p class="w-full mt-1">
            <a class="link w-4/12" href="https://www.abstractapi.com/ip-geolocation-api">{{ this.$translations[this.$root.language].readMore }}</a> - <a class="link w-8/12" href="https://www.abstractapi.com" target="_BLANK">View the official website</a>
          </p>
        </div>
        <div class="location-cookies flex flex-col mb-5 flex-wrap px-5">
          <h2 class="w-full relative font-bold">Google Analytics</h2>
          <p class="mb-2">{{ this.$translations[this.$root.language].serviceInstallCookies }}</p>
          <div class="flex flex-row w-full">
            <button id="google-cookies-allow" :class="this.$root.googleAnalyticsCookies === true ? 'allow' : ''" class="allow-button cookie-button bg-gray-300 text-white mr-4 p-3 rounded-sm sm:mb-0 w-32" @click="processCookiePolicy(true, 'googleAnalyticsCookies')">{{ this.$translations[this.$root.language].allow }}</button>
            <button id="google-cookies-deny" :class="this.$root.googleAnalyticsCookies === false ? 'deny' : ''" class="deny-button cookie-button bg-gray-300 text-white ml-4 p-3 rounded-sm w-32" @click="processCookiePolicy(false, 'googleAnalyticsCookies')">{{ this.$translations[this.$root.language].deny }}</button>
          </div>
          <p class="w-full mt-1">
            <a class="link" href="https://tarteaucitron.io/service/custom_analytics/" target="_BLANK">{{ this.$translations[this.$root.language].readMore }}</a> - <a class="link" href="https://policies.google.com/privacy" target="_BLANK">View the official website</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .personalize-container {
    background-color: #ffffff;
    color: black;
    z-index: 700;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 680px;
  }
  .personalize-upper {
    background-color: #f3f0d3;
  }
  .personalize-separator {
    margin: 10px auto 10px auto;
  }
  .allow {
    background-color: #008300;
  }
  .deny {
    background-color: #9C1A1A;
  }
  .personalize-bg {
    background-color: black;
    opacity: 0.3;
    z-index: 600
  }
  .personlize-banner {
    z-index: 500;
  }
  .menu-exit {
    position: absolute;
    top: -2px;
    right: 10px;
    color: #000000;
    font-size: 58px;
    cursor: pointer;
}
  .menu-exit:after {
    display: inline-block;
    content: "\00d7";
  }
</style>

<script>
export default {
  name: 'cookie-personalization',
  data: function () {
    return {
      cookiePolicy: '',
      cookieFlags: []
    }
  },
  methods: {
    processCookiePolicy (bool, cookieName) {
      var managementCookiesArray = ['websiteCookies', 'abstractCookies', 'googleAnalyticsCookies']
      var xhr = new XMLHttpRequest()
      var dataObject = {}
      const keysArray = ['totalFarmSize', 'numberOfFields', 'workingWidthCurrent', 'numberOfSectionsCurrent', 'controlTypeCurrent',
      'costOfProduct', 'workingWidthFuture', 'numberOfSectionsFuture', 'controlTypeFuture', 'implementType', 'fieldSize', 'amountOfProduct', 'spreaderType']
      const googleAnalyticsKeysArray = ['_ga', '_gid', '_gat']
      var websiteCookiesArray = []
      var googleAnalyticsCookiesKeysArray = []
      // If our sessionStorage variables exist, use those values.
      keysArray.forEach(key => {
        if (document.cookie.split(';').some((item) => item.trim().startsWith(key + '='))) {
          websiteCookiesArray.push(key)
        }
      })

      googleAnalyticsKeysArray.forEach(key => {
        if (document.cookie.split(';').some((item) => item.trim().startsWith(key + '='))) {
          googleAnalyticsCookiesKeysArray.push(key)
        }
      })

      for (const key of managementCookiesArray) {
        if (cookieName === 'allowAllCookies') {
          dataObject[key] = true
        } else if (cookieName === 'essentialCookiesOnly') {
          dataObject[key] = false
        } else {
          dataObject[cookieName] = bool
          break
        }
      }

      xhr.open('POST', '/submit-cookie-policy')
      xhr.setRequestHeader('Accept', 'application/json; charset=UTF-8')
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
      xhr.send(JSON.stringify({ dataObject, websiteCookieNames: websiteCookiesArray, googleAnalyticsCookieNames: googleAnalyticsCookiesKeysArray }))

      xhr.onloadend = response => {
        if (response.target.status === 200) {
          if (cookieName === 'allowAllCookies') {
            this.$root.websiteCookies = true
            this.$root.abstractCookies = true
            this.$root.googleAnalyticsCookies = true
          } else if (cookieName === 'essentialCookiesOnly') {
            this.$root.websiteCookies = false
            this.$root.abstractCookies = false
            this.$root.googleAnalyticsCookies = false
          } else {
            this.$root[cookieName] = bool
          }

          if (this.$root.isBoolean(this.$root.websiteCookies) === true && this.$root.isBoolean(this.$root.abstractCookies) === true && this.$root.isBoolean(this.$root.googleAnalyticsCookies) === true) {
            this.$root.cookiePolicySelected = true
          }

          if (this.$root.googleAnalyticsCookies === true && this.$root.abstractCookies === true && this.$root.websiteCookies === true) {
            this.$root.allowAllCookies = true
            this.$root.essentialCookiesOnly = false
          } else if (this.$root.googleAnalyticsCookies === true || this.$root.abstractCookies === true || this.$root.websiteCookies === true) {
            this.$root.essentialCookiesOnly = false
          } else {
            this.$root.allowAllCookies = false
             if (this.$root.cookiePolicySelected === true) {
              this.$root.essentialCookiesOnly = true
            }
          }

          if (this.$root.googleAnalyticsCookies === false || this.$root.abstractCookies === false || this.$root.websiteCookies === false) {
            this.$root.allowAllCookies = false
          }
          if (bool === true && (cookieName === 'allowAllCookies' || cookieName === 'abstractCookies')) {
              this.$root.automaticLanguageSelect()
          }
          this.$root.enableGoogleAnalytics()
        }
        if (response.target.status !== 200) {
          // Add error handler.
        }
      }
    },
    closeMenu () {
      var personalizeMenu = document.getElementById('cookie-personalization')
      personalizeMenu.classList.add('hidden')
    }
  }
}
</script>